import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            八大分类，满足您的所有阅读需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.filter((c) => c.slug !== 'all').map((cat, index) => {
            const icons = [
              'ri-heart-line',
              'ri-magic-line',
              'ri-sword-line',
              'ri-movie-line',
              'ri-search-eye-line',
              'ri-emotion-laugh-line',
              'ri-building-line',
              'ri-ancient-gate-line',
            ];
            const colors = [
              'bg-accent-100 text-accent-700',
              'bg-primary-100 text-primary-700',
              'bg-secondary-100 text-secondary-700',
              'bg-accent-100/80 text-accent-700',
              'bg-primary-100/80 text-primary-700',
              'bg-secondary-100/80 text-secondary-700',
              'bg-accent-100/60 text-accent-700',
              'bg-primary-100/60 text-primary-700',
            ];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg hover:bg-background-100 transition-colors group"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${colors[index]} transition-transform group-hover:scale-110`}>
                  <i className={`${icons[index]} text-xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}